import { createRouter, createWebHistory } from 'vue-router'
import Categories from '../views/Categories.vue'
import Category from '../views/Category.vue'

const routes = [
    {
        path: '/',
        name: 'Categories',
        component: Categories
    },
    {
        path: '/category/:slug',
        name: 'Category',
        component: Category
    }
]

export default createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    }
})
